/* eslint-disable react/no-array-index-key */
import FulfilledTitle from '@assets/fulfilled-title.svg';
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  BottomButtons,
  Panel, CheckBoxItem, PackageCheckboxGroup,
} from '@components';
import { PLATFORM_NAME, ClaimType, ShipmentStatus } from '@constants';
import { usePackageCheckbox } from './hooks';
import { ReasonDialog } from './reason-dialog';

import classes from '../choose/index.module.css';

export const CheckRA = () => {
  const {
    platform,
    fulfilledItems, returnCoverageDay = '',
    unFulfilledItems,
    isContinueBtnDisable,
    selectedItems,
    open, reason, reasonList,
    willChecked,
    onClickContinue,
    handleChange,
    clearItems,
    handleClose,
    handleOK,
    dialogReasonChange,
    commentsChange,
    handleItemEdit,
  } = usePackageCheckbox();
  const TextConfig = {
    Title: 'Protected item(s)',
    SubTitle: `You can return the item(s) to Seel within ${returnCoverageDay} days of delivery. Select the item(s) below to start the return.`,
  };

  const getFulfilledBlock = () => {
    if (!fulfilledItems?.length) {
      return null;
    }

    return (
      <Panel icon={FulfilledTitle} title="Fulfilled" className={classes.ful_panel}>
        {
          fulfilledItems.map((packageItem, packageIndex) => (
            <PackageCheckboxGroup
              key={packageItem.fulfillmentId + packageIndex}
              packageItem={packageItem}
              packageIndex={packageIndex}
              selectedItems={selectedItems}
              onChange={handleChange}
              handleItemEdit={handleItemEdit}
              reasonList={reasonList}
              orderNameTitleText={platform === PLATFORM_NAME.SIDELINESWAP ? 'Swap' : 'Order'}
              returnCoverageDay={returnCoverageDay}
              type={ClaimType.RA}
              disabled={((![PLATFORM_NAME.CTBIDS].includes(platform)) && packageItem.status !== ShipmentStatus.Delivered)}
              disabledText={`You can't initiate a return for the item(s), as they're already past the ${returnCoverageDay}-day return window from the date of delivery.`}
            />
          ))
        }
      </Panel>
    );
  };

  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={UnfulfilledTitle} title="Unfulfilled" className={classes.unful_panel}>
        {unFulfilledItems.map((item, index) => (
          <CheckBoxItem
            // eslint-disable-next-line react/no-array-index-key
            key={item.lineItemId + index}
            item={item}
            index={index}
            disabled
          />
        ))}
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TextConfig.Title} subTitle={TextConfig.SubTitle} />
      {getFulfilledBlock()}
      {getUnfulfilledBlock()}
      <BottomButtons
        onClickBack={clearItems}
        isContinueDisabled={isContinueBtnDisable}
        onClickContinue={onClickContinue}
      />
      {open && (
        <ReasonDialog
          open={open}
          reason={reason}
          handleClose={handleClose}
          handleOK={handleOK}
          onRadioChange={dialogReasonChange}
          onCommentsChange={commentsChange}
          reasonList={reasonList}
          currentItem={willChecked?.willCheckedItem}
        />
      )}
    </section>
  );
};
